import GARAGE_INITIAL_STATE from './garage.initial-state';
import GARAGE_MUTATIONS from './garage.mutations';
import GARAGE_GETTERS from './garage.getters';
import GARAGE_ACTIONS from './garage.actions';

// ============================================================================
// :: GARAGE MODULE STORE
// ============================================================================

const garageStore = {
  name: 'garage',
  namespaced: true,
  state: GARAGE_INITIAL_STATE(),
  mutations: GARAGE_MUTATIONS,
  actions: GARAGE_ACTIONS,
  getters: GARAGE_GETTERS,
};

export {
  garageStore,
};
